import {Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useEffect, useState} from 'react'
import TicketsService from '../../../services/ticket.service'
import ListTicket from './components/ListTicket'
import CreateTicketPage from './components/CreateTicketPage'
import TicketDetails from './components/TicketDetails'
import TicketHistory from './components/TicketHistory'

const TicketsWrapper = () => {
  const ticketsBreadCrumbs: Array<PageLink> = [
    {
      title: 'Tickets',
      path: '/tickets/dashboard',
      isSeparator: false,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      ></Route>

      <Route
        path='/'
        element={
          <>
            <PageTitle breadcrumbs={ticketsBreadCrumbs}>Ticket Dashboard</PageTitle>
          </>
        }
      />
      <Route
        path='list'
        element={
          <>
            <ListTicket />
          </>
        }
      />
      <Route
        path='create'
        element={
          <>
            <PageTitle breadcrumbs={ticketsBreadCrumbs}>Create Ticket</PageTitle>
            <CreateTicketPage />
          </>
        }
      />
      <Route
        path=':id'
        element={
          <>
            <PageTitle breadcrumbs={ticketsBreadCrumbs}>Ticket Details</PageTitle>
            <TicketDetails />
          </>
        }
      />
      <Route
        path=':id/history'
        element={
          <>
            <PageTitle breadcrumbs={ticketsBreadCrumbs}>Ticket History</PageTitle>
            <TicketHistory />
          </>
        }
      />
    </Routes>
  )
}

export default TicketsWrapper
